import axios from 'axios'
const baseURL = process.env.VUE_APP_API_URL;

const apiClient = axios.create({
  baseURL,
  withCredentials: false,
})

export default {
  getPivots() {
    return apiClient.get('/pivots')
  },
  getPivotData(pivot) {
    return apiClient.get(`/pivots/${pivot}`)
  },
  getSimilars(selectedPivot, selectedClassification, selectedBrand, otherPivots, nextPage) {
    return apiClient.get(`/similar?pivot=${selectedPivot}&classification=${selectedClassification}&brand=${selectedBrand}&others=${otherPivots}&page=${nextPage}`)
  },
  saveMatches(data) {
    return apiClient.put('/matches', data)
  }
}
